export default __webpack_public_path__ + "static/media/pos-dashboard.6f5d205d.jpg";